import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import ProductHalfCard from '../_components/ProductHalfCard/ProductHalfCard';
import ProductFullCard from '../_components/ProductFullCard/ProductFullCard';
import { getSelectedArea } from '../../Editor/_reducers/theme.reducer';
import { productsActions } from '../../Editor/_actions/products.actions';
import _ from 'lodash';
import shortid from 'shortid';
import { PLATFORMS, TRAY_LIKE_PLATFORMS } from '../../Editor/_helpers/constants';
import { createWixPaging, createWixQuery, createWixSortArray } from '../../Editor/utils/wixTools';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const useStyles = makeStyles(() => ({
    root: {
        backgroundColor: '#fff',
        cursor: 'grab',
        width: '100%'
    },
    filterBar: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: '0 10px'
    },
    title: (props) => ({
        backgroundColor: _.get(props, 'options.titleBackgroundColor', '#000000'),
        color: _.get(props, 'options.titleFontColor', '#ffffff'),
        fontSize: 14,
        fontWeight: "bold",
        margin: 0,
        padding: 10,
        textAlign: 'center',
        width: '100%'
    }),
    icon: {
        height: 22,
        marginLeft: 20,
        width: 22
    },
    productCardsWrapper: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: "wrap",
    }
}));

export default function CategoryScreen() {
    const dispatch = useDispatch();

    const selectedArea = useSelector(state => getSelectedArea(state));
    const data = selectedArea.sections.find(s => s.key === 'categorySettings');
    const platform = useSelector(state => state.StoreReducer.platform);
    const classes = useStyles({ ...data });
    const numberOfProducts = 10;

    const getEmptyProductsArray = () => {
        const idBase = shortid.generate();
        return Array.from({ length: numberOfProducts }, (_, i) => { return { id: `${idBase}-${i}` } })
    }

    const [products, setProducts] = useState(getEmptyProductsArray());

    useEffect(() => {
        const defaultSorting = _.get(data, 'options.defaultSorting', null);

        let filters = {};

        switch (platform) {
            case PLATFORMS.BAGY:
            case PLATFORMS.TRAY:
                filters = {
                    limit: numberOfProducts,
                    sort: _.isEmpty(defaultSorting) ? 'release_desc' : defaultSorting
                };
                break;
            case PLATFORMS.NUVEMSHOP:
                filters = {
                    per_page: numberOfProducts,
                    sort_by: _.isEmpty(defaultSorting) ? 'created-descending' : defaultSorting
                };
                break;
            case PLATFORMS.WIX:
                filters = createWixQuery(
                    null,
                    createWixPaging(1, numberOfProducts),
                    createWixSortArray([_.isEmpty(defaultSorting) ? 'createdDate-desc' : defaultSorting])
                );
                break;
            case PLATFORMS.IRROBA:
                filters = {
                    per_page: numberOfProducts,
                    sort_by: _.isEmpty(defaultSorting) ? 'release-desc' : defaultSorting
                };
                break;
            default:
                break;
        }

        dispatch(productsActions.getProducts(filters))
            .then(response => {
                setProducts(response.products);
            })
            .catch(() => {
                setProducts(getEmptyProductsArray());
            })
    }, [data.options.defaultSorting, dispatch]);

    return (
        <div className={classes.root}>
            <p className={classes.title}>Título da Categoria</p>
            <div className={classes.filterBar}>
                <p>10 produtos encontrados</p>
                <div>
                    <FontAwesomeIcon icon={['fas', 'sort']} className={classes.icon} />
                    {data.options.defaultView === 'grid' ?
                        <FontAwesomeIcon icon={['fas', 'list']} className={classes.icon} /> :
                        <FontAwesomeIcon icon={['fas', 'th-large']} className={classes.icon} />
                    }
                </div>
            </div>

            <div className={classes.productCardsWrapper}>
                {products.map(product => {
                if(data.options.defaultView === 'grid') {
                        return <ProductHalfCard key={`phc-${product.id}`} product={product} />
                    } else {
                        return <ProductFullCard key={`pfc-${product.id}`} product={product} />
                    }
                })}
            </div>
        </div>
    );
}
